import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { flatMap } from 'rxjs/operators';
import HttpService from './http.service';
import { FetchParams } from './http.types';
import { AxiosError, AxiosResponse } from 'axios';

export default (fetchParams: FetchParams): void => {
  const { params, onComplete, onError } = fetchParams;
  HttpService(params)
    .pipe(
      flatMap(
        (res): Array<AxiosResponse> => {
          if (res.status !== 201 && res.status !== 200) {
            return [res];
          }
          return [res];
        },
      ),
      catchError((err: AxiosError) => {
        return throwError(err);
      }),
    )
    .subscribe(onComplete, onError);
};
